@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.treeadd.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/fr.frux.feature.treeadd.resources/"

@delegate:ResourceContentHash(-2_087_589_840)
internal val Res.plurals.wizard_lost_photos: PluralStringResource by lazy {
      PluralStringResource("plurals:wizard_lost_photos", "wizard_lost_photos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 70),
      ))
    }

@delegate:ResourceContentHash(2_079_220_889)
internal val Res.plurals.wizard_species_count: PluralStringResource by lazy {
      PluralStringResource("plurals:wizard_species_count", "wizard_species_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81, 72),
      ))
    }

@delegate:ResourceContentHash(-1_594_288_421)
internal val Res.plurals.wizard_species_results: PluralStringResource by lazy {
      PluralStringResource("plurals:wizard_species_results", "wizard_species_results", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154, 178),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("wizard_lost_photos", Res.plurals.wizard_lost_photos)
  map.put("wizard_species_count", Res.plurals.wizard_species_count)
  map.put("wizard_species_results", Res.plurals.wizard_species_results)
}
